<script setup lang="ts">
import { onBeforeUnmount } from "vue";
import { RouterView, useRoute } from "vue-router";

import GlobalErrorBoundary from "@/components/shell/GlobalErrorBoundary.vue";
import { installSessionLifecycle } from "@/stores/sessionLifecycle";

const route = useRoute();
const disposeSessionLifecycle = installSessionLifecycle(
  () => route.matched.length > 0 && route.meta.immersive !== true,
);
onBeforeUnmount(disposeSessionLifecycle);
</script>

<template>
  <GlobalErrorBoundary>
    <RouterView />
  </GlobalErrorBoundary>
</template>
